var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    "aria-hidden": "true",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M134.28,81.2A34.28,34.28,0,1,0,100,115.48,34.32,34.32,0,0,0,134.28,81.2ZM100,105.48A24.28,24.28,0,1,1,124.28,81.2,24.3,24.3,0,0,1,100,105.48ZM169.74,81.2c0,14-7.74,32.35-23,54.45A326.39,326.39,0,0,1,111.64,178l-7.07-7.08c21.33-21.29,55.17-64.46,55.17-89.68a59.74,59.74,0,0,0-119.48,0c0,25.09,33.87,68.3,55.22,89.64l-7.07,7.07a332.28,332.28,0,0,1-34.93-42.14C38.07,113.52,30.26,95.16,30.26,81.2a69.74,69.74,0,0,1,139.48,0ZM100,175.37l7.07,7.07L100,189.51l-7.07-7.07Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.b823533f8d08b166d2475f7ca32df91b.svg";
export { ForwardRef as ReactComponent };